import {
  getHeaderMenuItemEligibility,
  HeaderMenuEligibilityContext,
  HeaderMenuItemEligibility,
} from 'src/client/containers/HeaderBar/helpers/useHeaderMenuItemVisibility';

export type FooterMenuEligibilityContext = Pick<
  HeaderMenuEligibilityContext,
  'hasUser' | 'configMoviesActive' | 'configMoviesRequiresAuth'
>;

export type FooterMenuItemEligibility = Pick<HeaderMenuItemEligibility, 'films' | 'photos' | 'models' | 'discounts'>;

// Header eligibility remains the source of truth for shared menu rules.
// Footer passes a narrowed context and this adapter supplies stable defaults
// for header-only fields so footer can reuse the same rule engine safely.
export const getFooterMenuItemEligibility = (
  context: FooterMenuEligibilityContext,
  overrides: HeaderMenuItemEligibility = {},
): FooterMenuItemEligibility => {
  const headerEligibility = getHeaderMenuItemEligibility(
    {
      hasUser: context.hasUser,
      configMoviesActive: context.configMoviesActive,
      configMoviesRequiresAuth: context.configMoviesRequiresAuth,
      // Footer does not depend on these today.
      configHasBlog: false,
      configHasUpdates: true,
      enableSeoCategoriesMenu: false,
      userValidSubscription: false,
    },
    overrides,
  );

  return {
    films: headerEligibility.films,
    photos: headerEligibility.photos,
    models: headerEligibility.models,
    discounts: headerEligibility.discounts,
  };
};
